import React from 'react'
import {Box} from '../../../webui/Box'
import {Paper} from '../../../webui/Paper'
import {LoadingSpinnerContainer} from '../../../webui/progress/LoadingSpinnerContainer'
import {Typography} from '../../../webui/Typography'
import {useAllBoxesLite} from '../../box/gql/useAllBoxesLite'
import {useAllRentals} from '../../rentals/gql/useAllRentals'
import {transformFilterToAllRentalsGQLFilter} from '../filter/utils/transformFilterToAllRentalsGQLFilter'
import {ProductsInBoxes} from '../ProductsInBoxes'
import {AppliedProductsFilter} from '../StatisticsProductsPage'
import {Product} from '../../../common/types/product'
import {ProductsPie} from './ProductsPie'
import {ProductsUseTimeTable} from './ProductsUseTimeTable'

interface Props {
  appliedFilter: AppliedProductsFilter
  allProducts: Product[]
}

const numberOfRentals = 1000

const selectedBoxesFilter =
  (selectedBoxIds: string[]) =>
  (box: {id: string}): boolean =>
    selectedBoxIds.length === 0 || selectedBoxIds.some((boxId) => box.id === boxId)

export const StatisticsProductsResults: React.FC<Props> = ({appliedFilter, allProducts}) => {
  const {selectedBoxes, onlyActiveBoxes} = appliedFilter

  const {data: allBoxesLite, loading: allBoxesLiteLoading} = useAllBoxesLite()

  const {
    data: {rentals},
    loading: allRentalsLoading,
    error,
  } = useAllRentals({
    variables: {
      pagination: {
        limit: numberOfRentals,
        offset: 0,
      },
      filter: transformFilterToAllRentalsGQLFilter({
        selectedBoxes,
        fromDate: undefined,
        selectedProducts: [],
        selectedGenders: [],
        onlyActiveBoxes: true,
        endDate: undefined,
      }),
    },
  })

  if (allRentalsLoading || allBoxesLiteLoading) {
    return <LoadingSpinnerContainer />
  }

  if (error) {
    return <div>{error.message}</div>
  }

  const filteredBoxesLite = allBoxesLite
    .filter(selectedBoxesFilter(selectedBoxes.map(({value}) => value)))
    .filter((box) => (onlyActiveBoxes ? box.active : true))

  return (
    <>
      <Paper>
        <Box p={2}>
          <Box m={2}>
            <Typography>Products in boxes</Typography>
          </Box>
          <ProductsInBoxes products={allProducts} boxes={filteredBoxesLite} />
        </Box>
      </Paper>

      <Box mt={2} />

      <Paper>
        <Box p={2}>
          <Box m={2}>
            <Typography>{`Product share in latest ${numberOfRentals} rentals`}</Typography>
          </Box>
          <ProductsPie rentals={rentals} />
        </Box>
      </Paper>

      <Box mt={2} />

      <Paper>
        <Box p={2}>
          <ProductsUseTimeTable rentals={rentals} />
        </Box>
      </Paper>
    </>
  )
}
